import React from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EventsViewToggle from './EventsViewToggle';
import { EVENT_TYPE_FILTERS } from '../eventsListData';

const roundedInputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    bgcolor: 'background.paper',
    fontSize: '0.875rem',
  },
};

const ToolbarSelect = styled(Select)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  fontSize: '0.875rem',
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    py: 1.25,
    pl: 1.5,
    pr: 4,
  },
}));

const EventsListToolbar = ({
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  viewMode,
  onViewModeChange,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
        mb: 2,
      }}
    >
      <TextField
        size="small"
        placeholder="Search"
        value={search}
        onChange={onSearchChange}
        sx={{ flex: '1 1 180px', minWidth: 160, maxWidth: 280, ...roundedInputSx }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            </InputAdornment>
          ),
        }}
      />

      {/* <Box sx={{ flex: '0 1 auto' }}>
        <DatePicker
          selected={filterDate}
          onChange={onFilterDateChange}
          placeholderText="Date"
          isClearable
          customInput={
            <DateFilterTrigger>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CalendarTodayOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                <Typography variant="body2" color={filterDate ? 'text.primary' : 'text.secondary'}>
                  {filterDate ? formatDate(filterDate, MOMENT_FORMATS.DATE) : 'Date'}
                </Typography>
              </Box>
              <KeyboardArrowDownIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            </DateFilterTrigger>
          }
        />
      </Box> */}

      <FormControl
        size="small"
        sx={{ minWidth: 130, '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' } }}
      >
        <ToolbarSelect
          value={typeFilter}
          onChange={onTypeFilterChange}
          displayEmpty
          IconComponent={KeyboardArrowDownIcon}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FilterListIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                {EVENT_TYPE_FILTERS.find((o) => o.value === selected)?.label ?? 'Event type'}
              </Typography>
            </Box>
          )}
        >
          {EVENT_TYPE_FILTERS.map((option) => (
            <MenuItem key={option.value || 'all'} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </ToolbarSelect>
      </FormControl>

      <Box sx={{ flexGrow: 1 }} />

      <EventsViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
    </Box>
  );
};

export default EventsListToolbar;
